<form class="vc-sale-wizard" (ngSubmit)="this.execute()">
  <header class="vc-sale-wizard__header">
    <span class="vc-sale-wizard__progress-label">
      Paso {{ currentStepIndex + 1 }} de {{ wizardOrder.length }}
    </span>
  </header>

  <div class="vc-sale-wizard__progress">
    <div
      class="vc-sale-wizard__progress-bar"
      [style.width.%]="progressPercent"
    ></div>
  </div>

  <ol class="vc-sale-wizard__steps">
    <li
      *ngFor="let step of wizardOrder; let index = index"
      [class.is-active]="step === currentStep"
      [class.is-complete]="index < currentStepIndex"
    >
      <span>{{ index + 1 }}</span>
      <small>
        {{
          step === "product"
            ? "Producto"
            : step === "payment"
              ? "Pago"
              : "Paciente y asociación"
        }}
      </small>
    </li>
  </ol>

  <div
    class="vc-sale-wizard__summary"
    *ngIf="this.product || this.payload?.price || this.patient"
  >
    <div class="vc-sale-wizard__summary-item" *ngIf="this.product">
      <i class="fas fa-box"></i>
      <strong>{{ this.product.name }}</strong>
    </div>

    <div
      class="vc-sale-wizard__summary-divider"
      *ngIf="this.product && this.payload?.price"
    ></div>

    <div
      class="vc-sale-wizard__summary-item vc-sale-wizard__summary-item--price"
      *ngIf="this.payload?.price"
    >
      {{ this.payload.price | number: "1.2-2" }}
      {{ this.site?.currency || "EUR" }}
    </div>

    <div
      class="vc-sale-wizard__summary-divider"
      *ngIf="(this.product || this.payload?.price) && this.patient"
    ></div>

    <div class="vc-sale-wizard__summary-item" *ngIf="this.patient">
      <i class="fas fa-user"></i>
      <strong>{{ this.patient.name }} {{ this.patient.surname }}</strong>
    </div>
  </div>

  <div class="vc-sale-wizard__content">
    <section class="vc-sale-step" *ngIf="currentStep === 'product'">
      <h3>{{ "SALES.TITLES.PRODUCT" | translate }}</h3>
      <p class="vc-sale-step__intro">
        Selecciona el producto que vas a vender y confirma el precio final.
      </p>

      <div class="vc-sale-panel">
        <div class="vc-sale-product-layout">
          <div class="vc-sale-product-layout__image">
            <app-product-image
              [image_url]="this.product?.image_url || defaultProuductImg"
            ></app-product-image>
          </div>

          <div class="vc-sale-grid vc-sale-grid--product">
            <div class="vc-sale-field vc-sale-field--full">
              <label class="vc-sale-field__label vc-sale-field__label--required">
                <i class="fas fa-search"></i>
                {{ "SALES.SELECTOR.PRODUCT.TITLE" | translate }}
              </label>
              <app-selector-site-products
                #siteProductsSelector
                [selected]="this.payload?.product"
                [placeholder]="'SALES.SELECTOR.PRODUCT.PLACEHOLDER'"
                [onSelect]="this.handleProduct.bind(this)"
              ></app-selector-site-products>
              <small class="vc-sale-field__error" *ngIf="this.errors.product">
                {{ this.errors.product | translate }}
              </small>
            </div>

            <div class="vc-sale-field">
              <label class="vc-sale-field__label vc-sale-field__label--required">
                <i class="fas fa-tag"></i>
                {{ "SALES.INPUT.PRICE.TITLE" | translate }}
              </label>
              <p-inputNumber
                name="price"
                [(ngModel)]="this.payload.price"
                [placeholder]="'SALES.INPUT.PRICE.PLACEHOLDER' | translate"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                mode="decimal"
                size="small"
                fluid
              />
              <small class="vc-sale-field__error" *ngIf="this.errors.price">
                {{ this.errors.price | translate }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="vc-sale-step" *ngIf="currentStep === 'payment'">
      <h3>{{ "SALES.TITLES.SALES_INFO" | translate }}</h3>
      <p class="vc-sale-step__intro">
        Indica cuándo se ha realizado la venta y cómo se ha cobrado.
      </p>

      <div class="vc-sale-panel">
        <div class="vc-sale-grid vc-sale-grid--2-cols">
          <div class="vc-sale-field">
            <label class="vc-sale-field__label vc-sale-field__label--required">
              <i class="fas fa-calendar-day"></i>
              {{ "SALES.INPUT.SALES_DATE.TITLE" | translate }}
            </label>
            <p-datepicker
              name="sales_date"
              [(ngModel)]="salesDate"
              [appendTo]="'body'"
              [showIcon]="true"
              [placeholder]="'SALES.INPUT.SALES_DATE.PLACEHOLDER' | translate"
              dateFormat="dd-mm-yy"
              size="small"
              fluid
            ></p-datepicker>
            <small class="vc-sale-field__error" *ngIf="this.errors.sales_date">
              {{ this.errors.sales_date | translate }}
            </small>
          </div>

          <div class="vc-sale-field">
            <label class="vc-sale-field__label vc-sale-field__label--required">
              <i class="fas fa-credit-card"></i>
              {{ "SALES.INPUT.PAYMENT_TYPE.TITLE" | translate }}
            </label>
            <app-selector-payment-type
              #paymentMethodSelector
              [selected]="this.paymentType"
              [placeholder]="'SALES.INPUT.PAYMENT_TYPE.PLACEHOLDER'"
              [onSelect]="this.handlePaymentMethod.bind(this)"
            ></app-selector-payment-type>
            <small
              class="vc-sale-field__error"
              *ngIf="this.errors.paymentType"
            >
              {{ this.errors.paymentType | translate }}
            </small>
          </div>
        </div>
      </div>
    </section>

    <section class="vc-sale-step" *ngIf="currentStep === 'association'">
      <h3>Paciente y tratamiento/cita asociada</h3>
      <p class="vc-sale-step__intro">
        Este paso es opcional. Si quieres, puedes vincular la venta a un
        paciente y a su tratamiento asociado.
      </p>

      <div class="vc-sale-panel">
        <div class="vc-sale-grid vc-sale-grid--2-cols">
          <div class="vc-sale-field">
            <label class="vc-sale-field__label">
              <i class="fas fa-user"></i>
              {{ "SALES.SELECTOR.PATIENT.TITLE" | translate }}
            </label>
            <app-patient-searcher
              #patientSearcher
              [selected]="this.patient"
              [onSelect]="this.handlePatient.bind(this)"
              [placeholder]="'SALES.SELECTOR.PATIENT.PLACEHOLDER'"
            ></app-patient-searcher>
          </div>

          <div class="vc-sale-field" *ngIf="this.patient">
            <label class="vc-sale-field__label">
              <i class="fas fa-notes-medical"></i>
              {{ "SALES.SELECTOR.TREATMENT.TITLE" | translate }}
            </label>
            <app-selector-patient-treatment
              #patientsTreatmentsSelector
              [selected]="this.treatment"
              [onSelect]="this.handleTreatment.bind(this)"
              [patients_id]="this.patient.id"
              [placeholder]="'SALES.SELECTOR.TREATMENT.PLACEHOLDER'"
            ></app-selector-patient-treatment>
          </div>
        </div>

        <div class="vc-sale-inline-note" *ngIf="!this.patient">
          <i class="fas fa-info-circle"></i>
          <span>
            Puedes guardar la venta sin paciente, o seleccionar uno para
            asociar el tratamiento.
          </span>
        </div>

        <div class="vc-sale-linked" *ngIf="this.patient">
          <div class="vc-sale-linked__identity">
            <span class="vc-sale-linked__avatar">
              {{ this.patient.name?.charAt(0) || "P" }}
            </span>
            <div>
              <strong>{{ this.patient.name }} {{ this.patient.surname }}</strong>
              <small *ngIf="this.treatment">
                {{ this.treatment.treatment?.name || "" }}
              </small>
            </div>
          </div>

          <button
            pButton
            type="button"
            class="p-button-outlined p-button-danger"
            (click)="clearAssociation()"
          >
            Limpiar asociación
          </button>
        </div>
      </div>
    </section>
  </div>

  <div class="vc-sale-wizard__actions">
    <button
      pButton
      type="button"
      class="p-button-outlined"
      (click)="goToPreviousStep()"
      [disabled]="!canGoBack"
    >
      Anterior
    </button>

    <button
      *ngIf="!isLastStep"
      pButton
      type="button"
      (click)="goToNextStep()"
    >
      Siguiente
    </button>

    <button *ngIf="isLastStep" pButton type="submit">
      {{ "COMMON.SUBMIT" | translate }}
    </button>
  </div>
</form>
